'use client'

import dynamic from 'next/dynamic'

import {SkeletonBlock} from '@/components/common/skeleton/SkeletonBlock'

// Loaded from a click in the footer. Its caller renders it inside a Modal, which mounts children
// only while open, so no extra gating is needed here.
export const DomainSelectLazy = dynamic(
  () => import('./DomainSelect').then(({DomainSelect}) => DomainSelect),
  {ssr: false, loading: () => <SkeletonBlock width="100%" height={180} />},
)
